import { Component, OnInit, Input } from '@angular/core';
import { WorkshopDefect } from '../../models/workshop-defect.model';
import { Vehicle } from '../../../vehicle/models/vehicle.model';
import { VehicleChecksAreas } from '../../../workshop/models/vehiclecheckarea.model';
import { VehicleSeverity } from '../../../workshop/models/vehicleseverity.model';
import { VehicleService } from '../../../vehicle/services/vehicle.service';
import { VehicleCheckService } from '../../../workshop/services/vehiclechecks.service';
import { catchError, take } from 'rxjs/operators';

@Component({
    selector: 'app-workshop-defect-form',
    templateUrl: './workshop-defect-form.component.html',
    styleUrls: ['./workshop-defect-form.component.scss'],
    standalone: false
})
export class WorkshopDefectFormComponent implements OnInit {

  @Input()
  defect: WorkshopDefect;

  vehicles: Vehicle[] = [];
  checkAreas: VehicleChecksAreas[] = [];
  severities: VehicleSeverity[] = [];

  statuses = [
    { id: 'open', label: 'Open' },
    { id: 'assigned', label: 'Assigned' },
    { id: 'in_progress', label: 'In Progress' },
    { id: 'complete', label: 'Complete' },
  ];

  constructor(
    private vehicleService: VehicleService,
    private vehicleCheckService: VehicleCheckService) { }

  ngOnInit(): void {
    this.vehicleService.getAllVehicles()
    .pipe(catchError((e) => { alert('Vehicles could not be loaded'); return e; }))
    .pipe(take(1))
    .subscribe((vehicles: Vehicle[]) => {
      this.vehicles = vehicles;
      this.vehicles.push({id: -1, registration: 'Select a vehicle...'} as any);
    });

    this.vehicleCheckService.getAllVehicleCheckAreas()
    .pipe(catchError((e) => { alert('Check areas could not be loaded'); return e; }))
    .pipe(take(1))
    .subscribe((areas: VehicleChecksAreas[]) => {
      this.checkAreas = areas;
      this.checkAreas.push({id: -1, name: 'Select a check area...'} as any);
    });

    this.vehicleCheckService.getAllVehicleSeverities()
    .pipe(catchError((e) => { alert('Severities could not be loaded'); return e; }))
    .pipe(take(1))
    .subscribe((severities: VehicleSeverity[]) => {
      this.severities = severities;
      this.severities.push({id: -1, notes: 'Select a severity...'} as any);
    });
  }

}
